export { SimilarDesignsSkeleton } from './SimilarDesignsSkeleton';
